
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 41 34","width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.428 8.622C9.71 6.91 4.531 7.382 4.48 7.388l-.193-1.991c.232-.023 5.763-.531 9.977 1.409l-.836 1.816zm-9.117 1.795c.311-.021 7.649-.513 12.896 3.023l-1.118 1.658c-4.668-3.144-11.561-2.691-11.632-2.686l-.146-1.995zm-.056 5.196c.298-.038 7.414-.914 12.95 2.793L16.09 20.07c-4.899-3.283-11.51-2.48-11.579-2.472l-.257-1.984zm.025 4.957c.3-.033 7.452-.736 12.923 2.91l-1.11 1.665c-4.86-3.24-11.538-2.594-11.605-2.587L4.28 20.57zm34.283 4.949V2.015a35.432 35.432 0 00-16.574 4.659l-.707.404v23.755a46.515 46.515 0 0117.281-5.314zM2 25.519a46.52 46.52 0 0117.282 5.314V7.078l-.706-.404A35.44 35.44 0 002 2.015v23.504zM39.563 0a1 1 0 011 1v25.427a1 1 0 01-.906.995l-.405.038a44.528 44.528 0 00-17.028 5.138l-1.469.79c-.044.024-.09.036-.137.053-.029.011-.055.025-.084.033a.974.974 0 01-.504 0c-.029-.008-.056-.022-.084-.033-.047-.017-.094-.029-.138-.053l-1.469-.79a44.505 44.505 0 00-17.027-5.137l-.405-.039A1 1 0 010 26.427V1a1 1 0 011-1 37.444 37.444 0 0118.569 4.938l.713.408.714-.408A37.431 37.431 0 0139.563 0zm-3.48 7.388c-.051-.006-5.23-.478-8.947 1.234l-.837-1.817c4.216-1.94 9.745-1.43 9.977-1.408l-.193 1.991zm.024 5.024c-.07-.006-6.966-.458-11.633 2.686l-1.117-1.658c5.246-3.535 12.584-3.045 12.896-3.023l-.146 1.995zm-12.748 5.995c5.535-3.708 12.65-2.832 12.949-2.793l-.257 1.983c-.07-.01-6.68-.811-11.58 2.472l-1.112-1.662zm.002 5.074c5.47-3.647 12.622-2.944 12.923-2.911l-.208 1.988c-.068-.008-6.746-.651-11.606 2.587l-1.11-1.664z"}})])
          )
        }
      }
    